// extracted by mini-css-extract-plugin
export default {"container":"CopyLabel_container__Dm4OD","h5SubHeader":"CopyLabel_h5SubHeader__unJ-q","bolderHeader":"CopyLabel_bolderHeader__YtfTO","copyButton":"CopyLabel_copyButton__k5zU1"};